import {
    Component,
    OnInit,
} from '@angular/core';
// Services
import { AcukwikairportsService } from "../../../services/acukwikairports.service";

@Component({
    selector: 'app-fbo-geofencing-dialog-new-cluster',
    styleUrls: ['./fbo-geofencing-dialog-new-cluster.component.scss'],
    templateUrl: './fbo-geofencing-dialog-new-cluster.component.html',
})
export class FboGeofencingDialogNewClusterComponent implements OnInit {

    public dataSources: any = {};
    public icao: string = '';
    public acukwikFbo: any = null;
    public loaderName: string = 'fbo-geofence-grid-loader';

    // Populated by AppDialogWrapperComponent
    data: any;
    dialogRef: { close: (result?: any) => void };

    constructor(
        private acukwikAirportsService: AcukwikairportsService
    ) { }

    ngOnInit(): void {
        if (this.data && this.data.icao) {
            this.icao = this.data.icao;
        }

        if (!this.dataSources.acukwikFbos) {
            this.loadAvailableFbos();
        }
    }

    public onStartClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close({ acukwikFbo: this.acukwikFbo });
        }
    }

    public onCancelClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    private loadAvailableFbos(): void {
        this.acukwikAirportsService.getAcukwikFboHandlerDetailByIcao(this.icao)
            .subscribe((response: any) => {
                this.dataSources.acukwikFbos = [];
                if (!response)
                    return;
                this.dataSources.acukwikFbos.push(...response);
            });
    }
}

